<route>
{
    "name": "suppliers-index",
    "meta": {
        "title": "Furnizori",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate", "secretar"],
        "fail": "/403"
    }
}
</route>
<template>
  <company-layout>
      <v-container fluid grid-list-xl>
          <v-row>
              <v-col>
                  <suppliers-index></suppliers-index>
              </v-col>
          </v-row>
      </v-container>
  </company-layout>
</template>

<script>
import CompanyLayout from "Layouts/Company.vue";
import SuppliersIndex from 'Components/suppliers/Index'

export default {
    components: {
        CompanyLayout,
        SuppliersIndex
    }
};
</script>
